module.exports = __webpack_public_path__ + "static/media/Elizabeth-Wirija-Campaign-Photography.ae99f562.jpg";